import { useState, useEffect } from "react";
import { BookOpen, ChevronRight } from "lucide-react";
import { Progress } from "./ui/progress";
import { fetchPokedex } from "../lib/api";

// Résumé du Pokédex sur la page d'accueil : le national en grand, puis une
// barre par région. Optionnel (réglage `pokedexHome`) — on ne charge donc les
// données que si le bloc est réellement affiché.
export const PokedexHomeCard = ({ onOpen }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchPokedex().then(setData).catch(err => console.error("Pokédex (accueil) :", err));
  }, []);

  if (!data) return null;

  const pct = (owned, total) => (total > 0 ? Math.round(owned / total * 100) : 0);
  const nat = data.national;

  return (
    <div className="mb-8 bg-zinc-900/50 border border-zinc-800 rounded-2xl p-6">
      <div className="flex items-baseline justify-between mb-3">
        <button onClick={onOpen}
          className="text-lg font-bold text-white flex items-center gap-2 hover:text-red-400 transition-colors">
          <BookOpen className="w-5 h-5 text-red-400" />Pokédex
          <ChevronRight className="w-4 h-4 text-zinc-500" />
        </button>
        <span className="text-sm text-zinc-400">
          <span className="text-white font-semibold">{nat.owned}</span>
          <span className="text-zinc-600">/{nat.total}</span>
          <span className="ml-2 text-emerald-400 font-semibold">{pct(nat.owned, nat.total)}%</span>
        </span>
      </div>
      <Progress value={pct(nat.owned, nat.total)} className="h-3 bg-zinc-800 mb-5" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3">
        {data.regions.map(r => (
          <button key={r.key} onClick={onOpen} className="text-left group">
            <div className="flex items-baseline justify-between mb-1">
              <span className="text-sm text-zinc-300 group-hover:text-white">{r.label}</span>
              <span className="text-xs text-zinc-500">
                {r.owned}/{r.total}
              </span>
            </div>
            <Progress value={pct(r.owned, r.total)} className="h-1.5 bg-zinc-800" />
          </button>
        ))}
      </div>
    </div>
  );
};
